import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin',
    children: [
      { path: '', redirect: '/admin/home' },
      { path: 'home', name: 'admin-home', component: () => import('@/modules/admin/AdminHome.vue') },
      { path: 'users', name: 'admin-users', component: () => import('@/modules/admin/UserManage.vue') },
      { path: 'permissions', name: 'admin-permissions', component: () => import('@/modules/admin/PermissionMatrix.vue') },
      { path: 'supervisor', name: 'admin-supervisor', component: () => import('@/modules/admin/SupervisorHome.vue') },
      { path: 'audit', name: 'admin-audit', component: () => import('@/modules/admin/AuditCenter.vue') },
      { path: 'handoff', name: 'admin-handoff', component: () => import('@/modules/admin/NotifyHandoffCenter.vue') }
    ]
  }
]

export default routes
